module.exports = __webpack_public_path__ + "static/media/jeeves_yule.4666b7c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/jeeves_yule.jpg
// module id = 92
// module chunks = 0